import url_servidor_mapas from './entorno.js';

export default class WFS {
  _servicio = 'wfs';
  _version = '2.0.0';
  _respuesta = 'GetFeature';
  _formato = 'application/json';

  _capa = undefined;
  _columnas = [];
  _cantidad = undefined;
  _orden = [];
  _filtro = undefined;

  _geojson = undefined;
  _geojsonCargado = false;
  
  constructor(capa) {
    this._capa = capa;
  }


  get espacioDeTrabajo() {
    return this._capa.includes(':')? this._capa.split(':')[0] : '';
  }

  get columnas() {
    return this._columnas.length? this._columnas.join(','): undefined;
  }
  set columnas(columnas) {
    if (Array.isArray(columnas)) {
      this._columnas = columnas;
    } else if (typeof columnas === 'string') {
        this._columnas = [columnas];
    }
  }

  get filtro() {
    return this._filtro;
  }
  set filtro(cql) {
    this._filtro = cql;
  }

  get orden() {
    return this._orden.length? this._orden.join(','): undefined;
  }
  set orden(orden) {
    if (Array.isArray(orden)) {
      this._orden = orden;
    } else if (typeof orden === 'string') {
        this._orden = [orden];
    }
  }
  
  /**
   * @param {Number} cantidad
   */
  set cantidad(cantidad) {
    this._cantidad = parseInt(cantidad);
  }

  get _parametrosGeoserver() {
    return {
      service: this._servicio,
      version: this._version,
      request: this._respuesta,
      typeNames: this._capa,
      outputformat: this._formato,
      propertyName: this.columnas,
      count: this._cantidad,
      sortBy: this.orden,
      cql_filter: this.filtro? `${this.filtro} `: undefined,
    }
  }

  get parametrosEnFormatoURL() {
    return Object.entries(this._parametrosGeoserver)
      .filter(([, valor]) => valor!=undefined) // Filtrar valores con valor
      .map(([id, valor]) => `${id}=${encodeURIComponent(valor)}`)
      .join('&')
  }

  get url() {
    return `${url_servidor_mapas}${this.espacioDeTrabajo}/wfs?${this.parametrosEnFormatoURL}`
  }

  /**
   * Devuelve el numero de features que coinciden con el filtro actual
   * @returns {Number} ConteoCoincidencia
   */
  get cargarConteoCoincidencia() {
    return fetch(`${this.url}&resultType=hits`).then(respuesta =>{
      if (respuesta.ok) return respuesta.text();
      else {
        console.info(respuesta);
        return '<none/>';
      }
    }).then(data => {
      return parseInt(new DOMParser()
        .parseFromString(data, "application/xml").firstChild
        .getAttribute('numberMatched'));
    }).catch(console.error);
  }
  
  cargarGeojson() {
    return fetch(this.url).then(respuesta => {
      if (respuesta.ok) return respuesta.json();
      else {
        console.info(respuesta);
        return {};
      }
    });
  }

  guardarGeojson() {
    return this._geojsonCargado? true
    : this.cargarGeojson().then(data => {
      if (data.hasOwnProperty('features')) {
        this._geojson = JSON.stringify(data);
        this._geojsonCargado = true;
        // console.log('si se guardaron');
        return true;
      } else return false;
    });
  }

  actualizarGeojsonGuardado() {
    this._geojsonCargado = false;
    return this.guardarGeojson();
  }

  get geojson() {
    if (this._geojsonCargado) {
      if (typeof(this._filtroGeojson)==="function") {
        const _geojson = {...JSON.parse(this._geojson)};
        _geojson.features = _geojson.features.filter(this._filtroGeojson);
        return _geojson;
      } else {
        return JSON.parse(this._geojson);
      }
    } else return {features: []};
  }

  /**
   * @param {Function} accion
   */
  set filtroGeojson(accion) {
    this._filtroGeojson = accion;
  }

  cargarFeatures() {
    return this.cargarGeojson().then(data => {
      if (data.hasOwnProperty('features')) {
        return data.features;
      } else return [];
    });
  }

  get cargarPropiedades() {
    return this.cargarFeatures().then(features => {
      return features.map(feature => feature.properties);
    });
  }

  cargarGeometrias() {
    return this.cargarFeatures().then(features => {
      return features.map(feature => feature.geometry);
    });
  }

  get cargarVertices() {
    return this.cargarGeometrias().then(geometrias => {
      return geometrias.map(geometria => {
        return geometria.coordinates.flat(
          tiposGeometria[geometria.type].flat);
      });
    });
  }

  get cargarLimites() {
    return this.cargarVertices.then(vertices => {
      return vertices.map(v => calcularLimites(v));
    });
  }

  get cargarLimitesTotales() {
    return this.cargarVertices.then(vertices => {
      return calcularLimites(vertices.flat());
    });
  }
}

function calcularLimites(vertices) {
  // xmin, ymin, xmax, ymax
  return [
    Math.min(...vertices.map(vertice => vertice[0])),
    Math.min(...vertices.map(vertice => vertice[1])),
    Math.max(...vertices.map(vertice => vertice[0])),
    Math.max(...vertices.map(vertice => vertice[1])),
  ];
}

const tiposGeometria = {
  'MultiPolygon': {
    flat: 2
  }
}


function consultarGeoserver(url, alResponderOk) {
  //console.log(url)
  if (typeof alResponderOk == 'function') {
    // ejecutar función despues de que geoserver de respuesta
    fetch(url).then(respuesta => {
      if (respuesta.ok) return respuesta.json()
      else console.log(respuesta)
    }).then(data => alResponderOk(data))
  } else {
    // hacer operación asincrona
  }
}

function GetFeature(layer, parametros, alResponderOk=undefined) {
  consultarGeoserver(generarUrl(layer, parametros), alResponderOk)
}